<template>
  <section class="banner-wrapper">
    <div
      class="banner"
      :style="{backgroundImage: `url(${require(`@/assets/banner-${banner}.jpg`)})`}"
    >
      <slot name="form" />
      <Spin
        v-if="loading"
        size="large"
        fix
      />
    </div>
  </section>
</template>

<script>
  import { Spin } from 'iview';

  export default {
    components: { Spin },
    props: {
      banner: {
        type: String,
        default: null
      },
      loading: {
        type: Boolean,
        default: false
      }
    }
  };
</script>